/**
 * 참고: https://github.kakaocorp.com/kakaopage/api/blob/2a8c28567166e8a9be255f5de0bc7a64aecf0713/common/src/main/java/com/kakaopage/common/model/enums/TicketStatus.java#L17
 */

export enum TicketStatus {
  NONE = 'NONE',
  // 구매완료
  TS01 = 'TS01',
  // 사용완료
  TS02 = 'TS02',
  // 환불완료
  TS03 = 'TS03',
}
